// The on-screen game panel (desktop + phone) for whichever table you're at:
// looks the game up in the registry and mounts its Overlay, plus the shared
// "How to play" guide and leaderboard dialogs. VR uses the in-world panels
// (GameTable3D → registry VRPanel) instead.

import React, { useCallback, useState } from 'react';
import { useGames, mySeat, amHost } from './gameStore';
import { getGameDef } from './registry';
import { RulesModal } from './kit/LobbyKit';
import { LeaderboardModal } from './Leaderboard';
import './kit/gameUi.css';

export function GameOverlay() {
  const near = useGames((s) => s.near);
  const entry = useGames((s) => (s.near ? s.tables[s.near] : undefined));
  const me = useGames((s) => s.me);
  const [dialog, setDialog] = useState<null | 'help' | 'board'>(null);
  const onHelp = useCallback(() => setDialog('help'), []);
  const onLeaderboard = useCallback(() => setDialog('board'), []);
  const close = useCallback(() => setDialog(null), []);

  const def = entry ? getGameDef(entry.kind) : undefined;
  if (!near || !entry || !def) return null;
  const table = entry.table;
  if (!table) {
    return entry.error ? <div className="gx-sp gx-sp--prompt"><span className="gx-sp-note">{entry.error}</span></div> : null;
  }
  const Overlay = def.Overlay;
  return <>
    <Overlay pid={near} worldId={entry.worldId} def={def} entry={entry} table={table} me={me}
      seat={mySeat(table, me)} isHost={amHost(table, me)} onHelp={onHelp} onLeaderboard={onLeaderboard} />
    {dialog === 'help' && <RulesModal def={def} onClose={close} />}
    {dialog === 'board' && <LeaderboardModal kind={def.kind} worldId={entry.worldId} onClose={close} />}
  </>;
}

/** True while the local player holds a seat (or hosts) at the table they're near. */
export function useSeatedAtGame(): boolean {
  return useGames((s) => {
    const e = s.near ? s.tables[s.near] : undefined;
    return !!e?.table && (mySeat(e.table, s.me) >= 0 || amHost(e.table, s.me));
  });
}

export default GameOverlay;
